import React, { useEffect, useRef, useState } from 'react';
import Styles from './styles.module.css';
import { ReactComponent as JapanMap } from './japan.svg';
import AlphaJapanLogo from './../../../image/home/schoolLogo/alpha-japan.png';
import AmbiLogo from './../../../image/home/schoolLogo/ambi.svg';
import ChibabiLogo from './../../../image/home/schoolLogo/chibabi.svg';
import DaiikuLogo from './../../../image/home/schoolLogo/daiiku.svg';
import GunbiLogo from './../../../image/home/schoolLogo/gunbi.svg';
import GurubiLogo from './../../../image/home/schoolLogo/gurubi.png';
import HollywoodWorldLogo from './../../../image/home/schoolLogo/hollywood-world.png';
import IseLogo from './../../../image/home/schoolLogo/ise.png';
import KagoshimaRibiyoLogo from './../../../image/home/schoolLogo/kagoshima-ribiyo.png';
import KoseLogo from './../../../image/home/schoolLogo/kose.png';
import ManoLogo from './../../../image/home/schoolLogo/mano.svg';
import MdfLogo from './../../../image/home/schoolLogo/mdf.svg';
import NagaokaLogo from './../../../image/home/schoolLogo/nagaoka.png';
import NagasakiKenbiLogo from './../../../image/home/schoolLogo/nagasaki-kenbi.svg';
import SobiLogo from './../../../image/home/schoolLogo/sobi.png';
import TohoLogo from './../../../image/home/schoolLogo/toho.svg';
import UnibiLogo from './../../../image/home/schoolLogo/unibi.svg';
import VerrougeLogo from './../../../image/home/schoolLogo/verrouge.svg';
import YicLogo from './../../../image/home/schoolLogo/yic.png';
import YokohamaLogo from './../../../image/home/schoolLogo/yokohama.png';

/* ============================================================
   memorii works をご利用いただいている美容学校
     左：日本地図＋各校の位置にピン
     右：学校リスト（ロゴ枠＋校名＋所在地）
   ピンとリストはホバーで相互ハイライト。ピンは初回表示時に落下アニメ。
   ※ ピン座標は japan.svg（geolonia / MIT）の viewBox 0 0 1000 1000 上の手動配置
   ============================================================ */

type School = { name: string; area: string; logo?: string; x: number; y: number };

/* x,y は japan.svg（viewBox 0 0 1000 1000）上の座標。
   各都道府県のポリゴン実測 bbox 内に、市区町村のおおよその位置で配置。 */
const SCHOOLS: School[] = [
  { name: '群馬県美容専門学校', area: '群馬県前橋市', logo: GunbiLogo, x: 568, y: 619 },
  { name: 'グルノーブル美容専門学校', area: '埼玉県神川町', logo: GurubiLogo, x: 552, y: 630 },
  { name: '埼玉東萌美容専門学校', area: '埼玉県越谷市', logo: TohoLogo, x: 603, y: 649 },
  { name: 'ユニバーサル美容専門学校', area: '千葉県船橋市', logo: UnibiLogo, x: 615, y: 658 },
  { name: '千葉美容専門学校', area: '千葉県千葉市', logo: ChibabiLogo, x: 621, y: 668 },
  { name: '真野美容専門学校', area: '東京都新宿区', logo: ManoLogo, x: 602, y: 664 },
  { name: 'コーセー美容専門学校', area: '東京都北区', logo: KoseLogo, x: 604, y: 658 },
  { name: 'M.D.F BEAUTY COLLEGE', area: '神奈川県横浜市', logo: MdfLogo, x: 598, y: 673 },
  { name: '横浜市立横浜商業高等学校別科', area: '神奈川県横浜市', logo: YokohamaLogo, x: 601, y: 680 },
  { name: '長岡美容専門学校', area: '新潟県長岡市', logo: NagaokaLogo, x: 558, y: 540 },
  { name: '名古屋綜合美容専門学校', area: '愛知県名古屋市', logo: SobiLogo, x: 469, y: 697 },
  { name: '伊勢理容美容専門学校', area: '三重県伊勢市', logo: IseLogo, x: 431, y: 743 },
  { name: 'ヴェールルージュ美容専門学校', area: '大阪府大阪市', logo: VerrougeLogo, x: 369, y: 725 },
  { name: 'アルファジャパン美容専門学校', area: '兵庫県姫路市', logo: AlphaJapanLogo, x: 332, y: 717 },
  { name: 'YICビューティモード専門学校', area: '山口県山口市', logo: YicLogo, x: 172, y: 751 },
  { name: 'ハリウッドワールド美容専門学校', area: '福岡県柳川市', logo: HollywoodWorldLogo, x: 122, y: 818 },
  { name: '長崎県美容専門学校', area: '長崎県長崎市', logo: NagasakiKenbiLogo, x: 80, y: 821 },
  { name: 'アンビシャス国際美容学校', area: '大分県大分市', logo: AmbiLogo, x: 180, y: 809 },
  { name: '鹿児島県理美容専門学校', area: '鹿児島県鹿児島市', logo: KagoshimaRibiyoLogo, x: 118, y: 903 },
  { name: '大育理容美容専門学校', area: '沖縄県那覇市', logo: DaiikuLogo, x: 312, y: 227 },
];

const PIN_PATH = 'M0 0 C -5 -10 -10 -16 -10 -23 A 10 10 0 1 1 10 -23 C 10 -16 5 -10 0 0 Z';

/* japan.svg（geolonia）の座標系。地図SVG・ピンSVG で必ず同じ値を使う。
   余白は CSS 側（.mapWrap の overflow + transform）で詰める。 */
const VIEW_BOX = '0 0 1000 1000';
const DEBUG_GRID = false;

const HomeSchoolMap = () => {
  const [active, setActive] = useState<number | null>(null);
  const [seen, setSeen] = useState(false);
  const wrapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = wrapRef.current;
    if (!el || typeof IntersectionObserver === 'undefined') {
      setSeen(true);
      return;
    }
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setSeen(true);
          io.disconnect();
        }
      },
      { threshold: 0.2 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div className={Styles.section} ref={wrapRef}>
      <div className={Styles.head}>
        <span className={Styles.kicker}>Partner schools</span>
        <h2>全国の美容学校と、つながっています。</h2>
        <p className={Styles.lead}>
          地図の色は都道府県ごとの登録サロン数、ピンは連携している美容学校です。
        </p>
      </div>

      <div className={Styles.body}>
        <div className={Styles.mapCol}>
        <div className={`${Styles.mapWrap} ${seen ? Styles.seen : ''}`}>
          <JapanMap className={Styles.mapBase} />
          <svg className={Styles.pins} viewBox={VIEW_BOX} aria-hidden="true">
            {DEBUG_GRID &&
              Array.from({ length: 21 }).map((_, i) => (
                <g key={`g${i}`}>
                  <line x1={i * 50} y1={0} x2={i * 50} y2={1000} stroke="#f0a" strokeWidth="0.7" />
                  <line x1={0} y1={i * 50} x2={1000} y2={i * 50} stroke="#f0a" strokeWidth="0.7" />
                  <text x={i * 50 + 2} y={12} fontSize="11" fill="#f0a">{i * 50}</text>
                  <text x={2} y={i * 50 - 2} fontSize="11" fill="#f0a">{i * 50}</text>
                </g>
              ))}
            {SCHOOLS.map((s, i) => (
              <g
                key={i}
                className={`${Styles.pin} ${active === i ? Styles.pinOn : ''}`}
                transform={`translate(${s.x} ${s.y})`}
                style={{ ['--i' as string]: i } as React.CSSProperties}
                onMouseEnter={() => setActive(i)}
                onMouseLeave={() => setActive(null)}
              >
                <g className={Styles.pinAnim}>
                  <path className={Styles.pinBody} d={PIN_PATH} />
                  <circle className={Styles.pinDot} cx="0" cy="-23" r="3.6" />
                </g>
              </g>
            ))}
          </svg>
        </div>

          <div className={Styles.legend}>
            <span className={Styles.legendCap}>色の濃さ＝都道府県別の登録サロン数</span>
            <span className={Styles.legendScale}>
              少
              <span className={Styles.legendBar} aria-hidden="true" />
              多
            </span>
          </div>
        </div>

        <ol className={Styles.list}>
          {SCHOOLS.map((s, i) => (
            <li
              key={i}
              className={`${Styles.row} ${active === i ? Styles.rowOn : ''}`}
              onMouseEnter={() => setActive(i)}
              onMouseLeave={() => setActive(null)}
            >
              <span className={Styles.logo}>
                {s.logo && <img src={s.logo} alt={`${s.name}のロゴ`} />}
              </span>
              <span className={Styles.rowText}>
                <span className={Styles.rowName}>{s.name}</span>
                <span className={Styles.rowArea}>{s.area}</span>
              </span>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
};

export default HomeSchoolMap;
